// extracted by mini-css-extract-plugin
module.exports = {"detail-L1":"SectionB2_detail-L1__7S_P6"};